// Dynamic import keeps papaparse out of the main entrypoint bundle
const loadPapa = () => import('papaparse').then((m) => m.default);

// Lazily loaded papaparse; module-private — callers should use usersJsonToCSV (async).
const jsonToCSV = async (json, delimiter, columns) => {
  const Papa = await loadPapa();
  return Papa.unparse(json, { delimiter, columns });
};

export const usersJsonToCSV = async (users, isTitleEnabled) => {
  const usersFormatted = users.map((user) => ({
    'Unique Id': user.oktaUserId,
    'First Name': user?.profile?.firstName,
    'Last Name': user?.profile?.lastName,
    Title: user?.profile?.title,
    'Last Login': user?.lastLoginTime,
    'Phone Number': user?.profile?.phoneNumber,
    'Office Line': user?.profile?.contactNumber,
    Email: user?.email,
    Roles: user?.roles?.join(', '),
    'Group Members': user?.groups?.join('; '),
    'Group Leads': user?.groupLeads?.join('; '),
    Active: user?.active ? 'Yes' : 'No',
  }));
  const columns = [
    'Unique Id',
    'First Name',
    'Last Name',
    ...(isTitleEnabled ? ['Title'] : []),
    'Last Login',
    'Phone Number',
    'Office Line',
    'Email',
    'Roles',
    'Group Members',
    'Group Leads',
    'Active',
  ];
  const delimiter = ',';
  return jsonToCSV(usersFormatted, delimiter, columns);
};
